import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'
import { ConfirmationDialog } from 'legacy/lut/components/shared/Confirm/ConfirmationDialog'

import { TRANSLATION_KEYS } from '../../translations'

export const editConfirmDialogIdentifier: ConfirmDialogIdentifier = 'AssortmentSaveConfirmDialog'

export const EditConfirmDialog = () => {
  return (
    <ConfirmationDialog
      translation
      identifier={editConfirmDialogIdentifier}
      text={TRANSLATION_KEYS.saveConfirm.saveMessage}
      submitText={TRANSLATION_KEYS.saveConfirm.saveButton}
      cancelText={TRANSLATION_KEYS.saveConfirm.cancelButton}
    />
  )
}
